export default __webpack_public_path__ + "static/media/questionnaire.90ca489e.svg";